// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footerList":"Footer_footerList__UXjuo","linksList":"Footer_linksList__-K0aY","copyrightList":"Footer_copyrightList__PEAr+"};